(()=>{
  const STORE_KEY='2in1flags:printify-mockups:v10';
  let scheduled=0;

  function readStore(){
    if(window.__2in1Mockups?.products)return window.__2in1Mockups;
    try{return JSON.parse(sessionStorage.getItem(STORE_KEY)||'null')||{products:{}};}
    catch(_){return {products:{}};}
  }

  function isFlagPage(page){
    return !!(page?.querySelector?.('.hfd__flag-product-gallery, .hfd__flag-media-label')||page?.dataset?.catalog==='flag');
  }

  function selectedVariantId(page){
    const input=page?.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"], input[name="id"]');
    return Number(input?.value)||0;
  }

  function activeSizeButton(page){
    return page?.querySelector?.('[data-size].is-active')||page?.querySelector?.('[data-size][data-front-url]')||null;
  }

  function flagStockUrls(page){
    if(!isFlagPage(page))return null;
    const btn=activeSizeButton(page);
    const front=btn?.dataset?.frontUrl||page?.getAttribute?.('data-stock-front')||'';
    const back=btn?.dataset?.backUrl||page?.getAttribute?.('data-stock-back')||front;
    if(!front)return null;
    return {front,back:back||front,stockOnly:true};
  }

  function currentUrls(page){
    const handle=page?.dataset?.productHandle||'';
    const flag=isFlagPage(page);
    if(!handle)return flag?flagStockUrls(page):null;
    const products=readStore().products||{};
    let product=products[handle];
    if(!product?.front){
      const catalog=window.__2in1PrintifyCatalog;
      const primary=catalog?.primaryHandle?.(handle)||handle;
      product=products[primary]
        ||(catalog?.handlesFor?.({handle,handles:[handle,primary]})||[]).map(name=>products[name]).find(item=>item?.front)
        ||Object.entries(products).find(([name,item])=>item?.front&&(catalog?.primaryHandle?.(name)||name)===primary)?.[1]
        ||null;
    }
    if(product&&!product.designArtOnly){
      const variantId=selectedVariantId(page);
      if(variantId&&product.variants?.[variantId]?.front&&!product.variants[variantId].designArtOnly){
        return product.variants[variantId];
      }
      const color=(()=>{
        const groups=[...page.querySelectorAll('fieldset.product-form__input, .product-form__input')];
        const colorGroup=groups.find(group=>/color/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
        return String(colorGroup?.querySelector('input:checked')?.value||'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
      })();
      const size=(()=>{
        const groups=[...page.querySelectorAll('fieldset.product-form__input, .product-form__input')];
        const sizeGroup=groups.find(group=>/size/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
        const radio=sizeGroup?.querySelector('input:checked')?.value;
        const active=page.querySelector('[data-size].is-active')?.dataset.size;
        const raw=radio||active||'';
        const t=String(raw).toLowerCase().replace(/×/g,'x').replace(/[^a-z0-9]+/g,' ').trim();
        const dim=t.match(/(\d+)\s*x\s*(\d+)/);
        return dim?`${dim[1]}x${dim[2]}`:t;
      })();
      if(color&&product.colors?.[color]?.front)return product.colors[color];
      if(size&&product.colors?.[size]?.front)return product.colors[size];
      if(color&&product.color===color&&product.front)return product;
      if(size&&product.color===size&&product.front)return product;
      // Flag sizes: never reuse another size's applied mockup — fall through to stock.
      if(flag)return flagStockUrls(page);
      if(size||color)return null;
      if(product.front)return product;
    }
    if(flag)return flagStockUrls(page);
    return null;
  }

  function galleryUrls(urls,page){
    if(!urls?.front){
      const generated=(urls?.images||[]).filter(Boolean);
      return generated.length?[...new Set(generated)]:[];
    }
    const flagPair=!!page?.querySelector('.hfd__flag-product-gallery, .hfd__flag-media-label');
    if(flagPair){
      const second=(urls.back&&urls.back!==urls.front)?urls.back:(urls.images||[]).find(src=>src&&src!==urls.front);
      return [urls.front,second||urls.front];
    }
    const slots=page?page.querySelectorAll('.product__media-list .product__media-item').length:0;
    if(slots===2||(urls.back&&urls.back!==urls.front)){
      return [urls.front,urls.back&&urls.back!==urls.front?urls.back:urls.front];
    }
    const generated=(urls.images||[]).filter(Boolean);
    return generated.length?[...new Set(generated)]:[urls.front,urls.back].filter(Boolean);
  }

  function setImage(img,url,{asStock=false}={}){
    if(!img||!url)return;
    if(asStock||!img.dataset.originalSrc){
      img.dataset.originalSrc=url;
      img.dataset.originalSrcset=url;
    }else if(!img.dataset.originalSrc){
      img.dataset.originalSrc=img.getAttribute('src')||'';
      img.dataset.originalSrcset=img.getAttribute('srcset')||'';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src',url);
    img.setAttribute('srcset',url);
    img.style.objectFit='contain';
    img.style.objectPosition='center center';
  }

  function mediaId(node){
    const raw=String(node?.dataset?.mediaId||node?.getAttribute?.('data-media-id')||'');
    const m=raw.match(/(\d+)$/);
    return m?m[1]:raw;
  }

  function restoreImage(img){
    const src=img?.dataset?.originalSrc;
    if(!src)return;
    img.setAttribute('src',src);
    img.setAttribute('srcset',img.dataset.originalSrcset||src);
  }

  function sync(){
    const page=document.querySelector('[data-product-design-page]');
    if(!page)return;
    const urls=currentUrls(page);
    const gallery=galleryUrls(urls,page);
    const items=[...page.querySelectorAll('.product__media-list .product__media-item')];
    const thumbs=[...page.querySelectorAll('.thumbnail-list__item')];
    const byMediaId=new Map();
    const stockOnly=!!urls?.stockOnly;

    if(!gallery.length){
      if(isFlagPage(page))return;
      items.forEach(item=>item.querySelectorAll('img[data-original-src]').forEach(restoreImage));
      thumbs.forEach(item=>item.querySelectorAll('img[data-original-src]').forEach(restoreImage));
      return;
    }

    if(stockOnly){
      page.classList.remove('has-printify-mockup');
      page.setAttribute('data-stock-front',urls.front||'');
      page.setAttribute('data-stock-back',urls.back||urls.front||'');
    }else{
      page.classList.add('has-printify-mockup');
    }

    items.forEach((item,i)=>{
      let url=gallery[i];
      if(urls&&page.querySelector('.hfd__flag-product-gallery')){
        const side=String(item.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
        if(side==='back')url=urls.back||urls.front||url;
        else if(side==='front')url=urls.front||url;
      }
      item.style.display=url?'':'none';
      if(!url)return;
      const id=mediaId(item);
      if(id)byMediaId.set(id,url);
      item.querySelectorAll('img').forEach(img=>setImage(img,url,{asStock:stockOnly}));
    });

    thumbs.forEach((item,i)=>{
      const url=gallery[i];
      item.style.display=url?'':'none';
      if(url)item.querySelectorAll('img').forEach(img=>setImage(img,url,{asStock:stockOnly}));
    });

    const modal=document.querySelector('.product-media-modal__content');
    if(modal){
      let shown=0;
      [...modal.children].forEach(item=>{
        const imgs=item.tagName==='IMG'?[item]:[...item.querySelectorAll('img')];
        if(!imgs.length)return;
        const url=byMediaId.get(mediaId(item))||byMediaId.get(mediaId(imgs[0]))||gallery[shown];
        shown+=1;
        item.style.display=url?'':'none';
        if(url)imgs.forEach(img=>setImage(img,url,{asStock:stockOnly}));
      });
    }
  }

  function schedule(delay=0){
    clearTimeout(scheduled);
    scheduled=setTimeout(sync,delay);
  }

  document.addEventListener('2in1:mockups',()=>schedule(0));
  document.addEventListener('2in1:product-zoom-open',()=>schedule(0));
  document.addEventListener('variant:change',()=>{
    schedule(0);
    schedule(50);
  });
  document.addEventListener('change',event=>{
    const page=event.target.closest?.('[data-product-design-page]');
    if(page&&event.target.matches('input,select')){
      schedule(0);schedule(50);
    }
  },true);
  document.addEventListener('input',event=>{
    const page=event.target.closest?.('[data-product-design-page]');
    if(page&&event.target.matches('input[type="radio"],select')){
      schedule(0);schedule(50);
    }
  },true);
  document.addEventListener('click',event=>{
    const sizeBtn=event.target.closest?.('[data-size]');
    if(sizeBtn&&sizeBtn.closest('[data-product-design-page]')){
      schedule(0);
      schedule(40);
      return;
    }
    if(!event.target.closest('modal-opener, .product__modal-opener, product-modal, .product-media-modal, .image-magnify-hover'))return;
    sync();
    requestAnimationFrame(()=>sync());
  },true);

  const observer=new MutationObserver(()=>schedule(60));
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>{
      sync();
      observer.observe(document.body,{childList:true,subtree:true});
    },{once:true});
  }else{
    sync();
    observer.observe(document.body,{childList:true,subtree:true});
  }
})();
